import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { TenantsStateModel } from './tenants-state.model';
import { TenantsStateSetTenants } from './tenants.actions';
import { environment } from '@work-frontend-monorepo/work-environments';
import { WorkTenant } from '@work-frontend-monorepo/work-rest-api';

const DEFAULT_STATE: TenantsStateModel = {
  tenants: [],
};

@State<TenantsStateModel>({
  name: environment.workStates.names.tenants || 'state__tenants',
  defaults: DEFAULT_STATE,
})
@Injectable()
export class TenantsState {
  @Selector()
  static hasTenants(state: TenantsStateModel): boolean {
    try {
      return state.tenants.length > 0;
    } catch (e) {
      return false;
    }
  }

  @Selector()
  static tenants(state: TenantsStateModel): WorkTenant[] {
    return state.tenants;
  }

  @Action(TenantsStateSetTenants)
  FavoritesStateToggleFavorite(ctx: StateContext<TenantsStateModel>, action: TenantsStateSetTenants) {
    ctx.patchState({ tenants: action.tenants });
  }
}
